import Legs from "./Legs";
import React, {useEffect, useState} from "react";
import './TripOverview.css';
import {Button} from "react-bootstrap";
import {toHrsMinsSecs, toMins, toHrs, toTime} from "../libs/formatLib";

import {ReactComponent as Map} from '../assets/icons/Map.svg';
import dayjs from "../dayjs";

function TripOverview({tripPlan, setShowMap}) {

    const [update, setUpdate] = useState(0);
    const [daysDiff, setDaysDiff] = useState(0);
    const [dateOfDeparture, setDateOfDeparture] = useState(null);
    const [hrsTilDeparture, setHrsTilDeparture] = useState(0);
    const [minsTilDeparture, setMinsTilDeparture] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => setUpdate(update => ++update), 60000);
        return () => clearInterval(timer);
    },[]);

    useEffect(() => {
        if(tripPlan) {
            const today = dayjs().startOf('d');
            const nextDeparture = tripPlan.nextDepartureDate;
            const diff = nextDeparture.diff(today, 'day')
            setDaysDiff(diff)
            setDateOfDeparture(tripPlan.nextDepartureDate);
            setHrsTilDeparture(toHrs(tripPlan.secondsTilDeparture));
            setMinsTilDeparture(toMins(tripPlan.secondsTilDeparture));
        }
    }, [setHrsTilDeparture, setMinsTilDeparture, setDaysDiff, tripPlan, update])

    // Single column card: header with date/time, then duration, then journey steps
    return (
        <div className="TripOverview singlecol-journey-overview">
            <div className="singlecol-journey-content-wrapper">
                <div className="singlecol-journey-header singlecol-journey-header-row">
                    <span className="singlecol-journey-dateblock">
                      <span className="singlecol-journey-date-label">Departing</span>
                      <span className="singlecol-journey-date-day">{dateOfDeparture ? dateOfDeparture.format('ddd') : ''}</span>
                      <span className="singlecol-journey-date-sub">{dateOfDeparture ? dateOfDeparture.format('D MMM') : ''}</span>
                    </span>
                    <span className="singlecol-journey-time-range">
                        <span style={{display: "flex", alignItems: "center", gap: "3px"}}>
                            <span className="singlecol-journey-time">{toTime(tripPlan.departureTime)}</span>
                            <span className="singlecol-journey-dash">–</span>
                            <span className="singlecol-journey-time">{toTime(tripPlan.arrivalTime)}</span>
                        </span>
                        <span className="singlecol-journey-duration">({toHrsMinsSecs(tripPlan.duration, false, true)})</span>
                    </span>
                </div>
            </div>
            <div className="singlecol-journey-steps-row">
                <div className="singlecol-journey-steps">
                    <Legs tripPlan={tripPlan}/>
                </div>
            </div>
            <div className="singlecol-journey-actions">
                <Button variant={"light"} className={'pill-btn show-map-btn'} size={"sm"} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowMap(true)
                }}><Map /><span>View Map</span></Button>
            </div>
        </div>
    )
}

export default React.memo(TripOverview);
